import React, { useState, useEffect } from 'react'
import { usePage } from '@inertiajs/react'

const FLASH_TYPES = {
  notice: {
    bg: 'bg-green-500',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    ),
  },
  alert: {
    bg: 'bg-red-500',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    ),
  },
  danger: {
    bg: 'bg-red-600',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
  },
}

export default function Flash() {
  const { flash } = usePage().props
  const [visible, setVisible] = useState({})

  useEffect(() => {
    if (flash) {
      const newVisible = {}
      Object.keys(FLASH_TYPES).forEach((type) => {
        if (flash[type]) {
          newVisible[type] = true
        }
      })
      setVisible(newVisible)

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setVisible({})
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [flash])

  const dismiss = (type) => {
    setVisible((prev) => ({ ...prev, [type]: false }))
  }

  if (!flash) return null

  const activeFlashes = Object.keys(FLASH_TYPES).filter(
    (type) => flash[type] && visible[type]
  )

  if (activeFlashes.length === 0) return null

  return (
    <div className="fixed top-20 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {activeFlashes.map((type) => {
        const config = FLASH_TYPES[type]
        return (
          <div
            key={type}
            className={`${config.bg} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in`}
            role="alert"
          >
            <span className="flex-shrink-0">{config.icon}</span>
            <span className="flex-1 text-sm">{flash[type]}</span>
            <button
              onClick={() => dismiss(type)}
              className="flex-shrink-0 hover:opacity-75 transition-opacity"
              aria-label="Fechar"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        )
      })}
    </div>
  )
}
